var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component--edit-view-list"},[_c('div',{staticClass:"inner-wrap"},[_c('List',{attrs:{"action":_vm.action,"path":_vm.path,"defaultFilter":_vm.defaultFilter,"defaultData":_vm.defaultData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }